import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { requestCreate, requestDelete, rugMfdToogle, rugMasterpieceToogle } from 'Global/Stores/rugs'
import { reservationCreateModalShow } from 'Global/Stores/modals'
import { userPermissions } from 'Components/Permissions/selectors'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    rug: selectors.detailRug(state),
    user: selectors.user(state),
    userPermissions: userPermissions(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    createRequest: (rugId, userId) => dispatch(requestCreate(rugId, userId)),
    deleteRequest: (requestId, userId) => dispatch(requestDelete(requestId, userId)),
    showCreateReservationModal: () => dispatch(reservationCreateModalShow()),
    toggleIsMasterpiece: id => dispatch(rugMasterpieceToogle(id)),
    toggleMarkedForDesigners: id => dispatch(rugMfdToogle(id)),
  })

  Enhancer.displayName = 'RugCardDetailedEnhancer'

  Enhancer.propTypes = {
    createRequest: PropTypes.func.isRequired,
    deleteRequest: PropTypes.func.isRequired,
    rug: PropTypes.object.isRequired,
    showCreateReservationModal: PropTypes.func.isRequired,
    toggleIsMasterpiece: PropTypes.func.isRequired,
    toggleMarkedForDesigners: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
